import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

function GalleryCarousel() {
  return (
    <Carousel fade height="200px">
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="../images/MKO/aerial_view.jpg"
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>Family Business</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="../images/MKO/front_view1.jpg"
          alt="Second slide"
        />

        <Carousel.Caption>
          <h3>Experience</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="../images/MKO/front_view2.jpg"
          alt="Third slide"
        />

        <Carousel.Caption>
          <h3>Vision</h3>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default GalleryCarousel;
